import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { basicDetailsBinder } from "libs/analytics/binders/onboarding/basicDetails";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { useEffect } from "react";
import { RoomsPage } from "../rooms/Page";

export const BasicPage = () => {
    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(basicDetailsBinder);

    return <RoomsPage />;
};
